import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import loadable from '@loadable/component';
import { bindActionCreators } from 'redux';
import { useRouter } from '@bibliocommons/utils-routing';
import { catalogBibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import connectRoute from 'app/routes/connectRoute';
import BibsActions from 'app/actions/BibsActions';
import CatalogBibsActions from 'app/actions/CatalogBibsActions';
import { getAppConfig } from 'app/selectors/AppSelector';
import { currentUserSelector } from 'app/selectors/AuthSelector';
import { getCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { getFeatureStatuses } from 'app/selectors/FeatureTogglzSelector';

const BibPageContainer = loadable(() => import('app/containers/BibPageContainer'));

export function BibPageRoute(props) {
  const { bibsActions, catalogBib } = props;
  const router = useRouter();

  useEffect(() => {
    if (catalogBib) {
      const metadataId = catalogBib.get('metadataId');

      // Ensure the url always reflects the actual ID of the localized bib
      router.replace(`/v2/record/${metadataId}`);

      // Load additional data on the client side, on page load,
      // and when the currentUser state changes (eg. log in).
      bibsActions.fetchUserTransactions([metadataId]);
      bibsActions.fetchAvailability(metadataId);
      bibsActions.fetchDiscovery(metadataId);
      bibsActions.fetchEvaluation(metadataId);
      bibsActions.fetchUGC(metadataId);
    }
  }, [props.currentUser]);

  return <BibPageContainer />;
}

BibPageRoute.propTypes = {
  catalogBib: catalogBibShape,
  currentUser: userIdentityShape,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  catalogBib: getCatalogBib(state),
  currentUser: currentUserSelector(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

function getRouteData({ state, dispatch, params }) {
  // Load the bib data only on the server-side
  if (__CLIENT__) return [];

  const featureTogglz = getFeatureStatuses(state);
  const fullyEnabled = featureTogglz.get(TOGGLZ_FEATURES.NERF_BIB_PAGE);
  const previewEnabled = featureTogglz.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_OPT_IN);
  const mobileApp = getAppConfig(state).get('mobileApp');

  if (fullyEnabled || previewEnabled || mobileApp) {
    return [dispatch(CatalogBibsActions.fetchCatalogBib(params.metadataId))];
  }

  return [];
}

export default connectRoute(BibPageRoute, { mapStateToProps, mapDispatchToProps, getRouteData });
